﻿export enum TableViewType {
    Undefined = 0,
    Grid = 1,
    List = 2
}